import { FONT_FAMILY } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    header: {
      color: colors.lightGray,
      fontFamily: FONT_FAMILY,
      fontSize: 18,
      fontWeight: 700,
      padding: '15px 25px',
      display: 'flex',
      alignItems: 'center',
      borderBottomColor: colors.silverGray,
      backgroundColor: colors.white,
      justifyContent: 'space-between'
    },
    closeIcon: {
      cursor: 'pointer'
    },
    buttonsContainer: {
      display: 'flex',
      padding: '11px 25px',
      background: colors.white
    },
    content: {
      padding: '0 25px',
      fontFamily: FONT_FAMILY,
      color: colors.approxBlack,
      backgroundColor: colors.white
    }
  }
  return styles
}

export default themeStyles
